import { t } from "i18next";
import React from "react";
import C from "Constants";

const PowerBy = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const href = C.COMPANY_URLS[companyName] || "#";
  return (
    <div className="text-center p-5">
      <a
        href={href}
        target={"_blank"}
        rel="noreferrer"
        className="px-1 cursor-pointer"
      >
        <img
          src={process.env.REACT_APP_COMPANY_LOGO}
          alt={companyName}
          className="inline-block w-6 h-6 mx-2"
        />
        <span className=" text-gray-500">{t("PoweredBy", {
          companyName,
        })}</span>
      </a>
    </div>
  );
};

export default PowerBy;
